import React, { useEffect, useState } from 'react';
import { Modal, Col, Row, Spin, DatePicker } from 'antd';
import propTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  AppointmentAvailability,
  AvailabilityText,
  ContentAppointment,
  ContentDatesAvailability,
  HighlightedText,
  IconExclamationCircleOutlined,
  RowContentAppointment,
  StyledIconCiOutlined,
  StyledSpan,
  TextP,
} from './styled';
import useValidateAvailability from './hooks/useValidateAvailability';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { finalCustomerSolutionIdRules } from '../../../../config/constants/finalCustomerSolutionRuleConstants';
import { getFullName } from '../../../../utility/finalCustomerUtils';

const ModalDataRepeatAppointments = ({ isOpen, cancelModalRepeat, incidentData, handleSubmitRepeat, dateValues }) => {
  const { datesAvailability, isLoading, availableCount, totalAppointments, checkDatesAvailability } =
    useValidateAvailability({ incidentData });
  const { translate: t } = useDictionaryTranslation();
  const solutionId = useSelector((state) => state.auth?.accountData?.solutionId);
  const finalCustomerSolutionRules = finalCustomerSolutionIdRules[solutionId] ?? finalCustomerSolutionIdRules.default;
  const [newDates, setNewDates] = useState([]);
  const getAvailableDates = () => {
    const availableDates = [];
    datesAvailability.forEach(({ isAvailable, date }) => {
      if (isAvailable) {
        availableDates.push(date);
      }
    });
    return availableDates;
  };

  const onUpdateVerify = async () => {
    const { idTypeService, idUser, idFinalCustomer } = incidentData;
    const dates = newDates.map((item) => item.date);
    await checkDatesAvailability({ idTypeService, idUser, idFinalCustomer, dates });
  };

  const handleDatePickerChange = (index, newDate) => {
    setNewDates((prevDates) => {
      const newDatesCopy = [...prevDates];
      const initialHour = moment(newDate._i).format('HH:mm:ss.SSS');
      newDatesCopy[index].date = `${moment(newDate._d).format('YYYY-MM-DD')}T${initialHour}`;
      return newDatesCopy;
    });
    onUpdateVerify();
  };

  useEffect(() => {
    setNewDates(datesAvailability);
  }, [datesAvailability]);

  return (
    <Modal
      open={isOpen}
      onCancel={cancelModalRepeat}
      onOk={() => handleSubmitRepeat(incidentData, getAvailableDates())}
      centered
      width="650px"
      okText="OK"
    >
      <Spin spinning={isLoading}>
        <Row justify="center">
          <Col xs={24}>
            <Row justify="center">
              <Col xs={2}>
                <IconExclamationCircleOutlined />
              </Col>

              <Col xs={22}>
                <TextP>
                  {t('appointmentAssignmentMessage')}
                  <HighlightedText>
                    {' '}
                    {getFullName(dateValues.selectedFinalCustomer, {
                      useFullName: finalCustomerSolutionRules.showName1,
                    })}
                    {' '}
                  </HighlightedText>
                </TextP>
              </Col>

              <Col xs={24}>
                <RowContentAppointment justify="center">
                  <Col xs={22}>
                    {datesAvailability.map((appointment, index) => (
                      <ContentDatesAvailability key={index} justify="center">
                        <Col xs={10} justify="start">
                          <ContentAppointment>
                            <span className="icon">
                              <StyledIconCiOutlined />
                            </span>

                            <DatePicker
                              size="small"
                              value={moment(appointment.date)}
                              format="dddd, DD-MM-YYYY"
                              onChange={(newDate) => handleDatePickerChange(index, newDate)}
                            />
                          </ContentAppointment>
                        </Col>
                        <Col xs={6}>
                          <StyledSpan>{moment(appointment.date).format('h:mm a')}</StyledSpan>
                        </Col>

                        <Col xs={6}>
                          <Row justify="center">
                            <AppointmentAvailability available={appointment.isAvailable}>
                              <AvailabilityText>
                                {appointment.isAvailable ? t('available') : t('notAvailable')}
                              </AvailabilityText>
                            </AppointmentAvailability>
                          </Row>
                        </Col>
                      </ContentDatesAvailability>
                    ))}
                  </Col>
                </RowContentAppointment>
              </Col>
              <Col xs={20}>
                <TextP>
                  {t('willBeAssigned')}
                  {' '}
                  <HighlightedText style={{ marginRight: '10px' }}>
                    {availableCount} {t('appointmentsOf')}
                    {totalAppointments}.
                  </HighlightedText>
                  {t('doyouAgree')}
                </TextP>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

ModalDataRepeatAppointments.propTypes = {
  isOpen: propTypes.bool,
  cancelModalRepeat: propTypes.func,
  incidentData: propTypes.object,
  handleSubmitRepeat: propTypes.func,
  dateValues: propTypes.object,
};

export default ModalDataRepeatAppointments;
